module.exports = "<span style=\"color:#333;\">Cargando ...</span>"


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/app/login/login.component.html
// module id = ../../../../../src/app/login/login.component.html
// module chunks = main